export class Cutting {
    title: string;
    url: string;
    description: string;
    thumb: string;
    uuid: string;
    path: string;
    bb: string;
}